<pm-widget-base-wrapper [isLoading]="isLoading" [name]="name">
  <ng-template pmWidgetTitle>
    {{ 'RESULT.INSIGHTS.WIDGETS.ABC_XYZ_ANALYSIS.TITLE' | translate }}
  </ng-template>

  <ng-template pmWidgetHeader>
    @if (this.groups) {
      <!-- Readonly Group field -->
      <mat-form-field
        color="primary"
        appearance="outline"
        subscriptSizing="dynamic"
      >
        <mat-label>
          {{ 'RESULT.INSIGHTS.WIDGETS.ABC_XYZ_ANALYSIS.GROUPING' | translate }}
        </mat-label>
        <input
          matInput
          class="cursor-default"
          [value]="this.groups"
          type="text"
          [readonly]="true"
          disabled="{{ isError }}"
        />
      </mat-form-field>
    }
  </ng-template>

  <ng-template pmWidgetContent>
    @if (this.isError) {
      <div class="flex justify-center items-center h-full text-center p-4">
        <pm-h3>
          {{ 'RESULT.INSIGHTS.GENERAL.TECHNICAL_ERROR' | translate }}
        </pm-h3>
      </div>
    } @else {
      <highcharts-chart
        class="w-full"
        id="abc-xyz-analysis-chart"
        [options]="chartOptions()"
      >
      </highcharts-chart>
    }
  </ng-template>

  <ng-template pmWidgetActions>
    @if (isDialogInstance) {
      <pm-button
        variant="subdued"
        [pmTooltip]="'RESULT.INSIGHTS.BUTTONS.EXIT_FULL_SCREEN_TOOLTIP'"
        (handleClick)="exitFullScreen()"
        [icon]="scanIcon"
      />
    } @else {
      <pm-button
        variant="subdued"
        [pmTooltip]="'RESULT.INSIGHTS.BUTTONS.FULL_SCREEN_TOOLTIP'"
        [icon]="scanIcon"
        (handleClick)="
          showFullScreen(AbcXyzAnalysisWidgetComponent, {
            volumeBinLimits: volumeBinLimits,
            forecastAccuracyBinLimits: forecastAccuracyBinLimits,
            groups: groups,
            planningPeriod: planningPeriod,
            targetUnit: targetUnit,
            errorMeasure: errorMeasure,
            timePeriodBackwardsInMonths: timePeriodBackwardsInMonths,
          })
        "
      />
    }
  </ng-template>
</pm-widget-base-wrapper>
